export const FEATURE = {
  POLL: true,
  SURVEY: true,
  // Ancestry not available in portal yet
  ANCESTRY: false,
  DNA_COLLECTION_KIT: true,
};
